import React, { ReactNode } from "react";
import Icon from "../general/Icon";
import { t } from "../../i18n";

interface Props {
  children?: ReactNode;
  i18nKey?: string;
  message?: string;
  svgSymbolId?: SvgSymbolId;
}

const ToastMessageBody = ({ children, i18nKey, message, svgSymbolId }: Props) => {
  return (
    <>
      {svgSymbolId && <Icon size="24" className="mr-7" symbolId={svgSymbolId}/>}
      <div className="Toastify__separator"/>
      <div className="flex flex-col md:flex-row flex-1 justify-between">
        <span
          className="inline-block mt-1 text-rolling-stone md:mt-0"
          dangerouslySetInnerHTML={{ __html: message || t(i18nKey) }}
        />
        {children}
      </div>
    </>
  );
};

export default ToastMessageBody;
